import { AxiosRequestConfig } from 'axios';

export interface Response {
  error?: string;
  message?: string;
  success: boolean;
}

export class BaseResponse<T extends Response> {
  constructor(public data: T) {}

  public hasError(): boolean {
    return !this.data.success;
  }
}

export type RequestConfiguration = AxiosRequestConfig & { target: string } & any;
